import React from 'react';
import { Link } from 'react-router-dom';
import './PoliticaDevoluciones.css';

const LogoComunicar = ({ height = 40 }) => (
  <svg height={height} viewBox="0 0 300 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="20" cy="28" rx="14" ry="12" fill="#82D8B3" opacity="0.7"/>
    <path d="M10 38 Q6 44 4 48 Q11 43 16 40Z" fill="#82D8B3" opacity="0.7"/>
    <ellipse cx="34" cy="22" rx="20" ry="17" fill="#82D8B3"/>
    <path d="M20 36 Q16 44 13 48 Q22 42 27 38Z" fill="#82D8B3"/>
    <circle cx="27" cy="22" r="2.2" fill="white"/>
    <circle cx="34" cy="22" r="2.2" fill="white"/>
    <circle cx="41" cy="22" r="2.2" fill="white"/>
    <text x="62" y="24" fontFamily="'DM Sans', sans-serif" fontWeight="700" fontSize="16" fill="#4db88a">Centro Comunicar</text>
    <text x="64" y="38" fontFamily="'DM Sans', sans-serif" fontWeight="400" fontSize="10" fill="#888">Comunicar - Lenguaje, Aprendizaje y Habla</text>
  </svg>
);

const IconArrow    = () => <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconCheck    = () => <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.2)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconX        = () => <svg viewBox="0 0 20 20" fill="none" width="16" height="16"><circle cx="10" cy="10" r="9" fill="rgba(220,38,38,.1)"/><path d="M7 7l6 6M13 7l-6 6" stroke="#dc2626" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconWhatsapp = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
const IconMail     = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconInfo     = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;
const IconClock    = () => <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;

const FECHA   = '20 de abril de 2026';
const EMPRESA = 'COMUNICAR DESARROLLO Y LENGUAJE EIRL';
const RUC     = '20615646939';
const EMAIL   = 'mf.gislimacentro@gmail.com';
const WA      = 'https://wa.me/51940686868?text=Hola%2C%20necesito%20informacion%20sobre%20una%20devolucion';

export default function PoliticaDevoluciones() {
  return (
    <div className="pd-page">

      {/* NAV */}
      <nav className="pd-nav">
        <Link to="/" className="pd-nav__logo"><LogoComunicar height={42}/></Link>
        <Link to="/" className="pd-nav__back">← Volver al inicio</Link>
      </nav>

      {/* HEADER */}
      <div className="pd-header">
        <div className="pd-header__inner">
          <p className="pd-header__label">Politica vigente desde {FECHA}</p>
          <h1>Politica de Cambios <em>y Devoluciones</em></h1>
          <p className="pd-header__sub">
            {EMPRESA} | RUC: {RUC}
          </p>
        </div>
      </div>

      <div className="pd-body">

        {/* AVISO IMPORTANTE */}
        <div className="pd-aviso">
          <div className="pd-aviso__icon"><IconInfo/></div>
          <div>
            <strong>Naturaleza digital de nuestros productos</strong>
            <p>
              La mayoria de nuestros productos son de <strong>naturaleza digital</strong> (cursos grabados, materiales descargables, acceso al aula virtual).
              Al tratarse de contenido que se entrega de forma inmediata y puede ser copiado, la politica de devoluciones
              es distinta a la de productos fisicos. Te recomendamos leer esta politica antes de realizar tu compra.
            </p>
          </div>
        </div>

        {/* RESUMEN RAPIDO */}
        <div className="pd-resumen">
          <h2 className="pd-resumen__titulo">Resumen rapido</h2>
          <div className="pd-resumen__grid">
            <div className="pd-resumen__col pd-resumen__col--si">
              <div className="pd-resumen__col-head">
                <IconCheck/> <strong>Si aplica devolucion</strong>
              </div>
              <ul>
                <li>Cobro duplicado o error en el pago</li>
                <li>El producto no corresponde a lo descrito</li>
                <li>El acceso no puede activarse por causa nuestra</li>
                <li>Archivo descargable corrupto o inutilizable</li>
                <li>Solicitud dentro de los 7 dias calendario</li>
              </ul>
            </div>
            <div className="pd-resumen__col pd-resumen__col--no">
              <div className="pd-resumen__col-head">
                <IconX/> <strong>No aplica devolucion</strong>
              </div>
              <ul>
  <li>Recursos descargables (por su naturaleza digital)</li>
  <li>Curso o material ya descargado o visualizado</li>
  <li>Cambio de opinion despues de acceder al contenido</li>
  <li>Incompatibilidad tecnica del dispositivo del usuario</li>
  <li>Solicitud fuera del plazo de 7 dias</li>
  <li>Cursos en vivo cuya clase ya inicio</li>
</ul>
            </div>
          </div>
        </div>

        {/* CONTENIDO COMPLETO */}
        <div className="pd-doc">

          <div className="pd-seccion">
            <h3>1. Ambito de aplicacion</h3>
            <p>
              La presente politica regula las solicitudes de cambio, devolucion y reembolso de productos
              y servicios adquiridos a traves de <strong>centrocomunicar.com</strong>, operado por
              <strong> {EMPRESA}</strong>, con RUC <strong>{RUC}</strong>, de conformidad con el
              Codigo de Proteccion y Defensa del Consumidor (Ley N 29571) y las normas concordantes
              del ordenamiento juridico peruano.
            </p>
          </div>

          <div className="pd-seccion">
            <h3>2. Productos digitales: cursos grabados y materiales descargables</h3>
            <p>
              Los cursos grabados y materiales descargables (imprimibles, kits, juegos terapeuticos)
              son entregados de forma digital e inmediata tras la confirmacion del pago.
              Por su naturaleza digital y de acceso instantaneo, <strong>no se realizan reembolsos</strong>
              una vez que el usuario ha accedido al contenido o descargado el archivo, salvo en los
              casos expresamente indicados en el punto 4 de esta politica.
            </p>
            <p>
              Se considera que el usuario ha accedido al contenido cuando:
            </p>
            <ul>
              <li>Ha iniciado la reproduccion del curso en el Aula Virtual.</li>
              <li>Ha descargado el archivo del material (imprimible, kit o juego).</li>
              <li>Ha visualizado mas del 10% del contenido total del curso.</li>
            </ul>
            <div style={{
              background:'#fef2f2', border:'1.5px solid #fecaca',
              borderRadius:12, padding:'1rem 1.2rem', marginTop:'.8rem',
            }}>
              <p style={{fontSize:'.9rem', color:'#991b1b', fontWeight:600, margin:0, lineHeight:1.7}}>
                Los recursos descargables, por su naturaleza digital, no cuentan con opcion de devolucion.
                Te recomendamos revisar bien la informacion del producto antes de realizar tu compra.
              </p>
            </div>
          </div>

          <div className="pd-seccion">
            <h3>3. Cursos en vivo y formaciones con fecha programada</h3>
            <p>
              Para cursos en vivo (webinars, talleres, clases en tiempo real), aplican las
              siguientes condiciones:
            </p>
            <ul>
              <li>
                <strong>Cancelacion con mas de 48 horas de anticipacion:</strong> reembolso del
                100% del monto pagado, descontando los costos de procesamiento del pago (si aplican).
              </li>
              <li>
                <strong>Cancelacion con menos de 48 horas:</strong> no aplica reembolso economico,
                pero se puede gestionar un cambio de fecha si el curso se repite, o un credito
                equivalente para otra formacion.
              </li>
              <li>
                <strong>Una vez iniciada la clase:</strong> no aplica reembolso bajo ninguna
                circunstancia.
              </li>
              <li>
                <strong>Cancelacion del evento por parte de Centro Comunicar:</strong> reembolso
                total del 100% o reprogramacion segun preferencia del usuario.
              </li>
            </ul>
          </div>

          <div className="pd-seccion">
            <h3>4. Casos en que SI aplica el reembolso</h3>
            <p>Centro Comunicar procedera con el reembolso en los siguientes casos:</p>
            <ul>
              <li>
                <strong>Cobro duplicado:</strong> si se realizo mas de un cargo por la misma compra,
                se reembolsa el importe duplicado en un plazo de 5 dias habiles.
              </li>
              <li>
                <strong>Error en el procesamiento:</strong> si el sistema registro un pago pero no
                activo el acceso por causa imputable a Centro Comunicar.
              </li>
              <li>
                <strong>Producto no conforme:</strong> si el contenido del curso o material es
                sustancialmente diferente a lo descrito en la plataforma.
              </li>
              <li>
                <strong>Archivo inutilizable:</strong> si el archivo descargado esta corrupto,
                incompleto o no puede abrirse con software estandar, y no se puede proporcionar
                un reemplazo funcional.
              </li>
              <li>
                <strong>Impossibilidad tecnica imputable a Centro Comunicar:</strong> si el acceso
                al Aula Virtual o al contenido no puede ser habilitado por razones tecnicas de
                nuestra plataforma, y no se resuelve en un plazo razonable.
              </li>
            </ul>
          </div>

          <div className="pd-seccion">
            <h3>5. Plazo para solicitar reembolso</h3>
            <div className="pd-plazo">
              <div className="pd-plazo__icon"><IconClock/></div>
              <div>
                <strong>7 dias calendario</strong> desde la fecha de compra o desde que se manifesto
                el defecto del producto.
                <p>
                  Solicitudes fuera de este plazo no seran aceptadas, salvo en casos de vicio
                  oculto o defecto no detectable en el momento de la compra.
                </p>
              </div>
            </div>
          </div>

          <div className="pd-seccion">
            <h3>6. Proceso para solicitar un reembolso o cambio</h3>
            <p>Para solicitar un reembolso, el usuario debe:</p>
            <ol>
              <li>
                <strong>Contactar al equipo de atencion al cliente</strong> por correo electronico
                a <a href={'mailto:' + EMAIL}>{EMAIL}</a> o por WhatsApp al +51 986 711 936.
              </li>
              <li>
                <strong>Indicar en el mensaje:</strong> nombre completo, correo de compra, nombre
                del producto, fecha de compra y motivo detallado de la solicitud.
              </li>
              <li>
                <strong>Adjuntar el comprobante de pago</strong> (captura de pantalla del cargo
                o numero de operacion).
              </li>
              <li>
                <strong>Esperar la evaluacion:</strong> el equipo revisara la solicitud y respondera
                en un plazo maximo de <strong>5 dias habiles</strong>.
              </li>
              <li>
                <strong>Reembolso:</strong> si procede, se realizara al mismo medio de pago original
                en un plazo de 5 a 10 dias habiles adicionales, segun el banco o plataforma de pago.
              </li>
            </ol>
          </div>

          <div className="pd-seccion">
            <h3>7. Politica de cambios</h3>
            <p>
              Si el usuario desea cambiar un producto por otro de igual o mayor valor, puede
              solicitarlo dentro del plazo de 7 dias, siempre que no haya accedido al contenido
              original. El cambio esta sujeto a disponibilidad y evaluacion del equipo.
            </p>
            <p>
              En caso de cambio por un producto de mayor valor, el usuario debera abonar la
              diferencia. En caso de menor valor, se emitira un credito para futuras compras.
            </p>
          </div>

          <div className="pd-seccion">
            <h3>8. Metodo de reembolso</h3>
            <p>Los reembolsos se realizaran por el mismo medio de pago utilizado en la compra:</p>
            <ul>
              <li>
                <strong>Tarjeta de credito o debito (Izipay):</strong> el reembolso se acredita
                en la tarjeta original. El tiempo de acreditacion depende del banco emisor
                (generalmente entre 5 y 10 dias habiles).
              </li>
              <li>
                <strong>Yape o transferencia bancaria:</strong> se solicita al usuario el numero
                de telefono Yape o cuenta bancaria para procesar la devolucion en un plazo de
                3 a 5 dias habiles.
              </li>
            </ul>
            <p>
              No se realizan reembolsos en efectivo ni por medios distintos al pago original.
            </p>
          </div>

          <div className="pd-seccion">
            <h3>9. Derechos del consumidor segun la Ley N 29571</h3>
            <p>
              Conforme al Codigo de Proteccion y Defensa del Consumidor, el consumidor tiene
              derecho a solicitar, a su eleccion, la reparacion, reposicion, devolucion del
              precio pagado o una reduccion del mismo cuando el producto o servicio no cumpla
              con las condiciones ofrecidas.
            </p>
            <p>
              Si consideras que tu solicitud de reembolso ha sido rechazada injustamente, puedes:
            </p>
            <ul>
              <li>
                Registrar un reclamo formal en nuestro{' '}
                <Link to="/libro-reclamaciones" className="pd-link">Libro de Reclamaciones</Link>.
              </li>
              <li>
                Presentar una denuncia ante el <strong>INDECOPI</strong> de forma gratuita en{' '}
                <a href="https://www.indecopi.gob.pe" target="_blank" rel="noopener noreferrer" className="pd-link">
                  www.indecopi.gob.pe
                </a>{' '}
                o llamando al <strong>224-7777</strong> (Lima) o <strong>0-800-4-4040</strong> (provincias, sin costo).
              </li>
            </ul>
          </div>

          <div className="pd-seccion">
            <h3>10. Modificaciones de esta politica</h3>
            <p>
              Centro Comunicar se reserva el derecho de modificar la presente politica en cualquier
              momento. Los cambios seran publicados en esta pagina con la fecha de actualizacion.
              La politica vigente al momento de la compra es la aplicable a dicha transaccion.
            </p>
          </div>

        </div>

        {/* CTA CONTACTO */}
        <div className="pd-cta">
          <div className="pd-cta__inner">
            <div>
              <strong>¿Tienes una solicitud de reembolso?</strong>
              <p>Contactanos directamente y lo resolvemos en un plazo de 5 dias habiles.</p>
            </div>
            <div className="pd-cta__btns">
              <a href={WA} target="_blank" rel="noopener noreferrer" className="pd-btn pd-btn--wa">
                <IconWhatsapp/> WhatsApp
              </a>
              <a href={'mailto:' + EMAIL} className="pd-btn pd-btn--email">
                <IconMail/> Enviar correo
              </a>
              <Link to="/atencion-cliente" className="pd-btn pd-btn--ghost">
                Formulario de contacto <IconArrow/>
              </Link>
            </div>
          </div>
        </div>

      </div>

      {/* FOOTER MINI */}
      <div className="pd-footer">
        <div className="pd-footer__inner">
          <LogoComunicar height={30}/>
          <p>{EMPRESA} | RUC: {RUC} | centrocomunicar.com</p>
          <div className="pd-footer__links">
            <Link to="/legal">Terminos y Privacidad</Link>
            <Link to="/libro-reclamaciones">Libro de Reclamaciones</Link>
            <Link to="/atencion-cliente">Atencion al Cliente</Link>
            <Link to="/">Inicio</Link>
          </div>
        </div>
      </div>

    </div>
  );
}